import { FC, ReactElement } from 'react';
import cn from 'classnames';
import { kebabCase } from 'lodash';

import { ShapeWithClassName } from '@app/constants';

import css from './SectionWithTitle.module.scss';

interface SectionTitleProps {
  title?: string;
  ariaLabel?: string;
  testId?: string;
  titleSibling?: ReactElement;
}

export const SectionWithTitle: FC<ShapeWithClassName<SectionTitleProps>> = ({
  title,
  ariaLabel = title,
  testId = kebabCase(title),
  className,
  titleSibling,
  children,
}) => {
  return (
    <section
      className={css.wrapper}
      aria-label={ariaLabel}
      data-auto={`record-${testId}-title`}
    >
      {title && (
        <div className={css.titleWrapper}>
          <h2 className={cn(css.title, className)}>{title}</h2>
          {titleSibling}
        </div>
      )}
      {children}
    </section>
  );
};
